import { Component, Input, OnInit } from '@angular/core'
import { CommonModule, Location } from '@angular/common'
import { Router } from '@angular/router'
import { UtilsService } from 'src/app/services/utils/utils.service'
import { IonicModule } from '@ionic/angular'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class HeaderComponent implements OnInit {
  @Input() title: string = ''
  // Optional translation key to render translated title dynamically
  @Input() titleKey?: string
  @Input() backUrl: string = ''
  @Input() back: boolean = true
  @Input() alt: boolean = false
  @Input() map: boolean = false
  isWeb: boolean = false
  constructor(private location: Location, private router: Router, private utilsService: UtilsService) {}

  goBack() {
    // Si hay una ruta específica de retorno, usarla (prioritario para mejorar UX en listados)
    if (this.backUrl) {
      this.router.navigate([this.backUrl]);
      return;
    }

    // Fallbacks según plataforma
    if (this.isWeb) {
      window.history.back();
    } else {
      this.location.back();
    }
  }
  async ngOnInit() {
    this.isWeb = await this.utilsService.detectIsWeb()



  }

}
